export default __webpack_public_path__ + "static/media/holycleansing.792f83cf.png";